import { useState, useContext, useEffect } from "react";
import "./edit-vendor-info.css";
import { FaTimes } from "react-icons/fa";
import AppContext from "../../../../context/app-context";
import { popup } from "../../../../vanilla-functions/model";

const EditVendorInfo = ({ isOpen, setIsOpen, selectedVendor, fetchVendors }) => {
  const { resolveBackendUrl, setIsLoading, isLoading } = useContext(AppContext);

  const [accountInfo, setAccountInfo] = useState({
    first_name: selectedVendor?.vendor_owner?.first_name || '',
    last_name: selectedVendor?.vendor_owner?.last_name || '',
    mobile: selectedVendor?.vendor_owner?.mobile || '',
    email: selectedVendor?.vendor_owner?.email || '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAccountInfo({
      ...accountInfo,
      [name]: value,
    });
  };

  const url = `${resolveBackendUrl(selectedVendor?.estateID)}/vendor/details/update/${selectedVendor?._id}`;
  const data = {
    vendor_owner: accountInfo
  }
  async function handleSubmit(e) {
    e.preventDefault();
    try {
      setIsLoading(true);
      const response = await fetch(url, {
        method: "PATCH",
        credentials: "include",
        headers: {
          "content-type": "application/json",
          token: localStorage.getItem("omstoken"),
        },
        body: JSON.stringify(data),
      });

      const returned = await response.json();
      await fetchVendors()
      popup(returned?.status || "Record Updated successfully");
      setIsOpen(false);
      setIsLoading(false);

    } catch (err) {
      setIsLoading(false);
      popup("Error communicating with estate server. You can try again later.");
    } finally {
      setIsLoading(false);
    }
  }

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content-body">
        <div className="vendor-info-div">
          <div className="vendor-heading-div">
            <div className="vendor-heading">VMS User account Information</div>
            <FaTimes onClick={() => setIsOpen(false)} cursor='pointer' />
          </div>
          <form onSubmit={handleSubmit} className="vendor-info-form">
            <div className="edit-form-input-div">
              <label>First Name</label>
              <input
                type="text"
                name="first_name"
                placeholder={selectedVendor?.vendor_owner?.first_name}
                onChange={handleChange}
              />
            </div>
            <div className="edit-form-input-div">
              <label>Last Name</label>
              <input
                type="text"
                name="last_name"
                placeholder={selectedVendor?.vendor_owner?.last_name}
                onChange={handleChange}
              />
            </div>
            <div className="edit-form-input-div">
              <label>Mobile</label>
              <input
                type="text"
                name="mobile"
                placeholder={selectedVendor?.vendor_owner?.mobile}
                onChange={handleChange}
              />
            </div>
            <div className="edit-form-input-div">
              <label>Email</label>
              <input
                type="email"
                name="email"
                placeholder={selectedVendor?.vendor_owner?.email}
                onChange={handleChange}
              />
            </div>
            <button type="submit">Submit</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditVendorInfo;

